<div class="what-we-offer-container">
    <div class="content-wrapper">
        <div class="text-section">
            <h1 class="heading">What We Offer</h1>
            <ul class="feature-list">
                <li><b>Next-Level Gaming:</b> Access a wide range of interactive games, tournaments, and challenges.</li>
                <li><b>Community First:</b> Connect with players across borders, share strategies, and grow together.</li>
                <li><b>Rewards & Recognition:</b> Earn bragging rights, prizes, and exclusive perks as you level up.</li>
                <li><b>Innovation at Play:</b> We fuse cutting-edge tech with authentic local content to deliver experiences that are uniquely ours.</li>
            </ul>
        </div>
        <div class="image-section">
            <img
                    src="assets/img/hero-about/about2x.png"
                    alt="Gamers with controller"
                    class="gamer-image"
            />
        </div>
    </div>
</div>

